var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7776 0.187753C12.0568 0.454317 12.0757 0.906153 11.8198 1.19695L4.27691 9.7684C4.15053 9.91198 3.97332 9.99562 3.78633 9.99983C3.59934 10.004 3.41881 9.92855 3.28656 9.79076L0.200839 6.57648C-0.0669464 6.29755 -0.0669464 5.84526 0.200839 5.56634C0.468632 5.28741 0.902799 5.28741 1.17059 5.56634L3.7499 8.25312L10.8088 0.231632C11.0647 -0.0591679 11.4985 -0.0788179 11.7776 0.187753Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.d2ea1589be838084a7e2ce922c0977f3.svg";
export { ForwardRef as ReactComponent };